import * as React from "react";

function JavascriptIcon(props) {
  return (
    <svg fill="none" viewBox="0 0 15 15" height="1em" width="1em" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15 0H0v15h15V0zM8 8a2 2 0 012-2h1.167C12.179 6 13 6.82 13 7.833V8h-1v-.167A.833.833 0 0011.167 7H10a1 1 0 000 2h1a2 2 0 110 4h-1a2 2 0 01-2-2h1a1 1 0 001 1h1a1 1 0 100-2h-1a2 2 0 01-2-2zM6 6v5a1 1 0 11-2 0H3a2 2 0 104 0V6H6z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default JavascriptIcon;
